var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-btn',{class:{
      'bg-nitro' : true ,
      'bg-transparent border-white' : _vm.$store.state.module.view_dark,
    },attrs:{"color":"white","outlined":"","fab":"","small":""},on:{"click":function($event){_vm.showMenuMobile = !_vm.showMenuMobile}}},[_c('v-icon',[_vm._v("fas fa-bars")])],1),_vm._v(" "),_c('v-bottom-sheet',{model:{value:(_vm.showMenuMobile),callback:function ($$v) {_vm.showMenuMobile=$$v},expression:"showMenuMobile"}},[_c('v-sheet',{attrs:{"height":"100%"}},[_c('ModuleContentMenu',{on:{"close":function($event){_vm.showMenuMobile=false}}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }